import React from 'react';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import Icon from '../../Common/Icon';
import DetailsRow from '../../Common/DetailsRow';
import { StyledIconContainer, StyledTimeContainer } from './style';
import Title from '../../Common/Title';
import { useTranslation } from 'react-i18next';
import { convertToPersian } from '../../../Utils/common.util';

type OpenTimesType = {
  openTimes: {
    endTime: string;
    startTime: string;
    title: string;
  }[];
  titleMargin?: number;
  direction?: string;
  bg?: string;
};
const OpenTime: React.FC<OpenTimesType> = ({
  openTimes,
  titleMargin,
  direction,
  bg
}) => {
  const { t } = useTranslation();

  return (
    !!openTimes.length && (
      <StyledDiv my={titleMargin || 12} width="100%">
        <Title title={t('home.openWorkTime')} mb={8} />
        <StyledDiv
          display="flex"
          gap={10}
          fontSize={2}
          fontWeight={6}
          direction={direction || 'rtl'}>
          <StyledIconContainer bg={bg || 'mainBackground'}>
            <Icon name="calendar_month" fontSize={19} color="minorText" />
          </StyledIconContainer>
          <StyledTimeContainer bg={bg || 'mainBackground'}>
            {openTimes.map((item, index) => (
              <DetailsRow
                key={item.title}
                title={item.title}
                value={
                  <StyledSpan fontSize={2} color="normalText">
                    {t('home.openTimeValue', {
                      startTime: convertToPersian(item.startTime).slice(0, 5),
                      endTime: convertToPersian(item.endTime).slice(0, 5)
                    })}
                  </StyledSpan>
                }
                mb={index !== openTimes.length - 1 ? 6 : 'unset'}
              />
            ))}
          </StyledTimeContainer>
        </StyledDiv>
      </StyledDiv>
    )
  );
};

export default OpenTime;
